import { Tooltip } from '@/components/basic';

export default function ResourceHoursHelpTooltip() {
  return (
    <Tooltip>
      <div className="text-base font-normal text-gray-800">
        Custom hours allow admins to restrict reservations from being made for a
        period of time.{' '}
      </div>
    </Tooltip>
  );
}
